import { isAlive } from "mobx-state-tree";
import { ChartApiResponse } from "../../hooks/useChartData";
import { normalizeFlowRateUnit } from "../../convert";
import PrecipSensor from "../../models/PrecipSensor";
import { ISelectedSensor } from "../../models/SelectedSensor";

const rootApiUrl = process.env.REACT_APP_API_URL || "https://jefulleralert.com/api";

const fetchChart = async (selected: ISelectedSensor): Promise<ChartApiResponse | undefined> => {
    let url = rootApiUrl + '/tabular/' + selected.sensor.id
    if (PrecipSensor.is(selected.sensor)) {
        url += "?accumulate=True&bin=1d";
    }
    const headers = { "Accept": "application/json" };
    const res = await fetch(url.toString(), { headers });
    if (!isAlive(selected)) {
        return undefined;
    }

    if (!res.ok) {
        throw new Error("Bad response from chart API");
    }

    const response = await res.json() as ChartApiResponse;
    if (selected.display.measure === "discharge") {
        const measure = Object.keys(response.meta.units).find((key) =>
            key.startsWith("discharge")
        );
        if (measure !== undefined) {
            response.meta.units[measure] = normalizeFlowRateUnit(
                response.meta.units[measure]
            );
        }
    }

    return response;
};

export default fetchChart;